import { useEffect } from "react";

export const SITE_NAME = "Capital Care International Hospital";
// TODO: replace with the live production domain once the site is deployed.
export const SITE_URL = "https://www.example.com";

function setMetaByName(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setMetaByProperty(property, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Updates document.title and meta description/OG/Twitter tags for the current
 * in-app view. Canonical/og:url intentionally stay pinned to the site root:
 * this app has no real per-page URLs (no router), so the homepage is the only
 * address a crawler or shared link can actually reach.
 */
export default function usePageSeo({ title, description } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Trusted Care, Compassionate Excellence`;
    const desc = description || `${SITE_NAME} is a modern secondary & tertiary care hospital in G-8, Islamabad offering 24/7 emergency, ICU, NICU, surgery and 100+ specialist doctors.`;

    document.title = fullTitle;
    setMetaByName("description", desc);
    setMetaByProperty("og:title", fullTitle);
    setMetaByProperty("og:description", desc);
    setMetaByName("twitter:title", fullTitle);
    setMetaByName("twitter:description", desc);
  }, [title, description]);
}
